module.exports = __webpack_public_path__ + "static/img/black-3.c402f493.png";